import React, { useEffect, useState } from "react";
import useAPI from "hooks/useAPI";
import moment from "moment";
import MirumGrid from "components/MirumGrid";
const DiscountCodes = () => {
  const [discountCodes, setDiscountCodes] = useState([]);
  const { API } = useAPI({});

  useEffect(() => {
    getAndSetDiscountCodes();
  }, []);
  const getAndSetDiscountCodes = async () => {
    const data = await API.get(`/admin/discount-codes`);
    let discountCodes = data?.discountCodes.map((discountCode) => {
      return {
        ...discountCode,
        expires: moment(discountCode.expires).format("DD/MM/YYYY HH:MM"),
      };
    });
    setDiscountCodes(discountCodes);
  };
  return (
    <div className="container mx-auto py-8">
      {/* <MirumGrid
        rowData={discountCodes}
        columnDefs={[
          { headerName: "Percentage", field: "percentage", filter: true },
          { headerName: "Code", field: "code", filter: true },
          { headerName: "Expires", field: "expires", filter: true },
          { headerName: "Status", field: "status", filter: true },
        ]}
      /> */}
      <h1>Discount Codes</h1>
      <br />
      <table className="mirum-table">
        <thead>
          <th>Percentage</th>
          <th>Code</th>
          <th>Expires</th>
          <th>Status</th>
        </thead>
        <tbody>
          {discountCodes.map((discountCode) => (
            <tr>
              <td>{discountCode.percentage}%</td>
              <td>{discountCode.code}</td>
              <td>
                {/* {discountCode.expires}&nbsp; */}
                {moment(discountCode.expires, "DD/MM/YYYY HH:MM").format(
                  "DD/MM/YYYY HH:MM"
                )}
              </td>
              <td>{discountCode.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default DiscountCodes;
